import { Validator } from '@vista-digital/validator';
import { defaultFilmImageConfig, filmImageConfigValidatorSchema } from '../../image/types/config';
import { FilmThumbnailMediaType, filmThumbnailMediaTypeValidator } from './media-type';
/**
 * Default configuration options for the Film Thumbnail component.
 */
export const defaultFilmThumbnailConfig = Object.assign(Object.assign({}, defaultFilmImageConfig), { mediaType: FilmThumbnailMediaType.Poster, showWatchlistButton: true });
export const filmThumbnailConfigValidatorSchema = Object.assign(Object.assign({}, filmImageConfigValidatorSchema), { mediaType: filmThumbnailMediaTypeValidator, showWatchlistButton: Validator.boolean() });
export const filmThumbnailConfigValidator = Validator.object(filmThumbnailConfigValidatorSchema);
//# sourceMappingURL=config.js.map